function getShipTypeSummary(items) {
    const hasGiftCertificatesOnly = items?.every((item) => item.name === 'Gift Certificate')

    if (hasGiftCertificatesOnly) {
        return ''
    }

    const hasBOPIS = items?.some((item) => item.bopis_type === 'BOPIS')
    const hasShip = items?.some((item) => item.bopis_type === 'Ship')

    if (hasBOPIS && hasShip) return 'Ship, BOPIS'
    if (hasBOPIS) return 'BOPIS'
    if (hasShip) return 'Ship'

    return ''
}

export default getShipTypeSummary
